import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Lottie from "react-lottie";
import FadeIn from "react-fade-in";

import { fetchSearchResults } from "../redux/actions";

import SearchBookLandingPage from "./staticComponents/SearchBookLandingPage";
import SearchResultsNotFound from "./staticComponents/SearchResultsNotFound";
import SearchResultsPagination from "./SearchResultsPagination";
import loadingBooks from "../animations/loadingBooks.json";

import Typography from "@material-ui/core/Typography";

import BookCard from "./BookCard";

const renderResultsList = (results) => {
  return results.items.map((item) => {
    return (
      <BookCard
        key={item.id}
        id={item.id}
        title={item.volumeInfo.title}
        authors={item.volumeInfo.authors}
        publisher={item.volumeInfo.publisher}
        description={item.volumeInfo.description}
        cover={
          item.volumeInfo.imageLinks
            ? item.volumeInfo.imageLinks.smallThumbnail
            : ""
        }
        rating={
          item.volumeInfo.averageRating ? item.volumeInfo.averageRating : 0
        }
      />
    );
  });
};

const renderBookSearchResults = (results, pageNumber, query) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingBooks,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (results) {
    if (results.isLoading) {
      return (
        <>
          <Lottie
            options={defaultOptions}
            height={400}
            width={400}
            isStopped={false}
            isPaused={false}
            speed={6}
          />
          <Typography align="center" variant="h5" component="h5">
            Searching Books...
          </Typography>
        </>
      );
    } else if (!results.items) {
      return <SearchResultsNotFound />;
    } else if (results.items) {
      return (
        <>
          <SearchResultsPagination
            pageNumber={pageNumber}
            results={results}
            query={query}
          />
          <FadeIn delay={100}>{renderResultsList(results)}</FadeIn>
          <SearchResultsPagination
            pageNumber={pageNumber}
            results={results}
            query={query}
          />
        </>
      );
    } else {
      return <div>Something went Wrong!</div>;
    }
  } else {
    return <SearchBookLandingPage />;
  }
};

function BookSearchResults(props) {
  const bookSearchResults = useSelector((state) => state.searchResults);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      fetchSearchResults(
        props.match.params.query,
        props.match.params.pageNumber
      )
    );
  }, [props.match.params.query, props.match.params.pageNumber, dispatch]);

  return renderBookSearchResults(
    bookSearchResults,
    props.match.params.pageNumber,
    props.match.params.query
  );
}

export default BookSearchResults;
